import { Text, View } from "@react-pdf/renderer";
import { PDFTableColumn } from "components/PDF/Table";
import { ParcelaAcordo } from "core/features/acordo/typings";
import { formatMoney } from "infra/helpers/number";
import moment from "moment";
import { useMemo } from "react";
import { getSituacaoParcelaText } from "./../util/getSituacaoParcelaText";

function useParcelasAcordoPdfColumns(): PDFTableColumn<ParcelaAcordo>[] {
  return useMemo(() => {
    const columns: PDFTableColumn<ParcelaAcordo>[] = [];

    columns.push({
      title: "Parcela",
      flexGrow: 0.2,
      render: (_, index) => (
        <View>
          <Text>{index + 1}ª</Text>
        </View>
      ),
    });

    columns.push({
      title: "Vencimento",
      flexGrow: 0.3,
      render: (original) => (
        <View>
          <Text>{moment(original.dataVencimento).format("DD/MM/YYYY")}</Text>
        </View>
      ),
    });

    columns.push({
      title: "Valor",
      flexGrow: 0.6,
      textAlign: "right",
      render: (original) => (
        <View>
          <Text>{formatMoney(original.valor)}</Text>
        </View>
      ),
    });

    columns.push({
      title: "Situação",
      flexGrow: 0.6,
      textAlign: "right",
      render: (original) => (
        <View>
          <Text>{getSituacaoParcelaText(original)}</Text>
        </View>
      ),
    });

    return columns;
  }, []);
}

export default useParcelasAcordoPdfColumns;
